import App from '@/app/App';
import '@/index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';

/** `yarn dev:mock`일 때만 MSW를 켠다. 빌드 결과물에는 포함되지 않는다 */
const enableMocking = async () => {
  if (!import.meta.env.DEV || import.meta.env.VITE_USE_MOCK !== 'true') return;
  try {
    const { worker } = await import('@/mocks/browser');
    await worker.start({ onUnhandledRequest: 'bypass' });
  } catch {
    // 서비스 워커 등록이 막힌 환경에서는 페이지 안 interceptor로 대신한다
    const { startFallbackMocking } = await import('@/mocks/fallback');
    startFallbackMocking();
  }
};

void enableMocking().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
